import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

function UrunSearch({ setModel, value, searchParam, disabled, onModelReady }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const [search, setSearch] = React.useState('');
  const [fromBarkod, setFromBarkod] = React.useState(false);
  const SessionUser = getUser();

  React.useEffect(() => {
    // let active = true;
    debugger
    if(SessionUser.TenantId == 75){
      if (search.length > 4 && (open)){
        axios.get(`/GetSiriusModels/${search.toString().toLocaleLowerCase(localStorage.i18nextLng_normalized)}`)
          .then((res) => {
            // if (active || fromBarkod) {
            const response = res.data;
            if (response.length > 0) {
              fromBarkod ? updateModel(response[0]) : setOptions(response);
            } else {
              fromBarkod ? updateModel({ ACIKLAMA: '', KUL_MODEL_KODU: '' }) : setOptions([]);
            }
            // }
          }).catch((err) => {
            if (fromBarkod) {
              updateModel({ ACIKLAMA: '', KUL_MODEL_KODU: search });
            }
            setOptions([]);
          });
      }
      else{
        return;
      }
  }
    else if (search.length > 4 && (open || fromBarkod)) {
      axios.get(`/GetSiriusModels/${search.toString().toLocaleLowerCase(localStorage.i18nextLng_normalized)}`)
        .then((res) => {
          // if (active || fromBarkod) {
          const response = res.data;
          if (response.length > 0) {
            fromBarkod ? updateModel(response[0]) : setOptions(response);
          } else {
            fromBarkod ? updateModel({ ACIKLAMA: '', KUL_MODEL_KODU: '' }) : setOptions([]);
          }
          // }
        }).catch((err) => {
          if (fromBarkod) {
            updateModel({ ACIKLAMA: '', KUL_MODEL_KODU: search });
          }
          setOptions([]);
        });
    }
    // return () => {
    //     active = false;
    // };
    // eslint-disable-next-line
  }, [search, open, loading, fromBarkod]);

  React.useEffect(() => {
    if (searchParam.length > 0) {
      setFromBarkod(true);
      setSearch(searchParam);
    }
  }, [searchParam]);

  const updateModel = (model) => {
    setModel(model);
    value.ACIKLAMA = model.ACIKLAMA;
    value.KUL_MODEL_KODU = model.KUL_MODEL_KODU;
    setFromBarkod(false);
    if (onModelReady) {
      onModelReady(model);
    }
  };

  return (
    <Autocomplete
      id="asynchronous-demo"
      open={open}
      value={value}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      getOptionLabel={(option) => (option.KUL_MODEL_KODU ? (`${option.KUL_MODEL_KODU} - ${option.ACIKLAMA}`) : '')}
      options={options}
      filterOptions={(options, state) => options}
      loading={loading}
      disabled={disabled}
      onChange={(event, newValue) => {
        if (newValue && newValue.ACIKLAMA) {
          updateModel(newValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          onChange={(e) => { setSearch(e.target.value); }}
          variant="outlined"
          helperText={value ? value.ACIKLAMA : ''}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}

export default UrunSearch;
